import { MeasurementSystem } from './measurementSystem';

export class GlobalSettings {
	public static APP_ID: number = 30;
	public static MORE_SYMBOL_VALIDATION: number = 200;
	public static ELEMENT_SIBLINGS_TOLERANCE: number = 0.01;
	public static PACKING_OFFSET_PERCENT: number = 0.1;
	public static MULTI_SETTINGS_LABEL: string = '—';
	public static DEFAULT_PRODUCT_GROUP_ANGLE: number = 0;
	public static ACCURACY: number = 8;
	public static CONVERSION_DISTANCE_COEFFICIENTS = {
		toMeters: 1,
		fromMeters: 1,
		toInches: 39.370078740157,
		fromInches: 0.0254,
		toFeet: 3.2808398950131,
		fromFeet: 0.3048
	};
	public static CONVERSION_MASS_COEFFICIENTS = {
		toKilograms: 1,
		fromKilograms: 1,
		toPounds: 2.2046226218487757,
		fromPounds: 0.45359237
	};
	public static MIN_ELEMENT_SIZES: Map<MeasurementSystem, number> = new Map<MeasurementSystem, number>([
		[MeasurementSystem.Metrics, 0.001],
		[MeasurementSystem.Imperial, 0.04]
	]);
	public static BACK_IMAGE_OPACITY: number = 0.3;
	public static AUTOSAVE_DEFAULT_TIME_S: number = 180;
}